import React from 'react'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

export interface DateProps extends ReactDatePickerProps {}

export function Date({ ...props }: DateProps) {
  return <DatePicker {...props} />
}
